<app-smart-alert-template [notification]="notification | async"
                          [channels]="channels | async"
                          name="alerts.smart_alerts.smart_channel_insights.title"
                          description="alerts.smart_alerts.smart_channel_insights.description"></app-smart-alert-template>
